'use client';

import { useState } from 'react';

export const useGitHubLogin = () => {
  const [error, setError] = useState<string>('');

  const handleGitHubLogin = async () => {
    try {
      setError('');
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}/auth/github/oauth-url?mode=login`
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'GitHub認証URLの取得に失敗しました');
      }

      const data = await response.json();

      if (data.error) {
        throw new Error(data.error);
      }

      // Google認証ページにリダイレクト
      window.location.href = data.url;
    } catch (error) {
      setError(error instanceof Error ? error.message : 'GitHubログインに失敗しました');
    }
  };

  return { handleGitHubLogin, error };
};
